import src from "IMAGE";
export default { src, width: 300, height: 280, blurWidth: 0, blurHeight: 0};
